export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
    },
    hero: {
      title: 'Guiding You to Success',
      subtitle: 'Strategic Consulting for Growth and Excellence',
      cta: 'Learn More',
    },
    about: {
      title: 'About Crossroads Consulting LDA',
      p1: 'At Crossroads Consulting LDA, we believe that every business stands at a crossroads—a pivotal moment where strategic decisions shape the future. With over two decades of combined expertise, our team specializes in guiding organizations through complex challenges and transformative opportunities.',
      p2: "Our approach is built on three core principles: deep industry insight, data-driven analysis, and collaborative partnership. We don't just provide recommendations; we work alongside your team to implement sustainable solutions that drive measurable results. From startups seeking rapid growth to established enterprises navigating market disruption, we tailor our services to meet your unique needs.",
      p3: "What sets us apart is our commitment to excellence and our track record of success. Our clients consistently achieve their strategic objectives, whether that's entering new markets, optimizing operations, or positioning for long-term competitive advantage. When you partner with Crossroads Consulting LDA, you gain more than a consultant—you gain a trusted advisor dedicated to your success.",
    },
    services: {
      title: 'Our Services',
      subtitle:
        'Comprehensive consulting solutions designed to accelerate your business growth and operational excellence',
      items: {
        strategic: {
          title: 'Strategic Planning',
          desc: 'Develop clear, actionable strategies that align with your vision and drive sustainable growth in competitive markets.',
        },
        business: {
          title: 'Business Development',
          desc: 'Identify and capitalize on new opportunities, expand your market presence, and build strategic partnerships.',
        },
        market: {
          title: 'Market Analysis',
          desc: 'Gain deep insights into market trends, competitive landscapes, and customer behaviors to inform decision-making.',
        },
        operations: {
          title: 'Operations Optimization',
          desc: 'Streamline processes, reduce costs, and enhance efficiency across your organization for maximum productivity.',
        },
        financial: {
          title: 'Financial Advisory',
          desc: 'Navigate complex financial decisions with expert guidance on budgeting, forecasting, and capital allocation.',
        },
        change: {
          title: 'Change Management',
          desc: 'Lead organizational transformation with structured approaches that ensure smooth transitions and stakeholder buy-in.',
        },
      },
    },
    contact: {
      title: 'Get In Touch',
      subtitle:
        'Ready to take your business to the next level? Contact us today to discuss how we can help you achieve your goals.',
      form: {
        name: 'Name *',
        email: 'Email *',
        message: 'Message *',
        submit: 'Send Message',
        sending: 'Sending...',
        success: "Thank you for your message! We'll get back to you soon.",
        errors: {
          nameRequired: 'Name is required',
          emailRequired: 'Email is required',
          emailInvalid: 'Please enter a valid email address',
          messageRequired: 'Message is required',
          sendFailed:
            'Failed to send message. Please try again or contact us directly by email.',
        },
      },
      info: {
        title: 'Contact Information',
        desc: "We're here to answer your questions and discuss how we can support your business objectives.",
        address: {
          label: 'Address',
          value: [
            '123 Business Avenue',
            'Suite 456',
            'Lisbon, Portugal 1000-001',
          ],
        },
        phone: {
          label: 'Phone',
        },
        email: {
          label: 'Email',
        },
        hours: {
          title: 'Business Hours',
          weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
          weekend: 'Saturday - Sunday: Closed',
        },
      },
    },
    footer: {
      rights: '© 2026 Crossroads Consulting LDA. All rights reserved.',
    },
  },
  pt: {
    nav: {
      home: 'Início',
      about: 'Sobre',
      services: 'Serviços',
      contact: 'Contactos',
    },
    hero: {
      title: 'Guiando-o ao Sucesso',
      subtitle: 'Consultoria Estratégica para Crescimento e Excelência',
      cta: 'Saber Mais',
    },
    about: {
      title: 'Sobre a Crossroads Consulting LDA',
      p1: 'Na Crossroads Consulting LDA, acreditamos que cada empresa se encontra numa encruzilhada—um momento crucial onde as decisões estratégicas moldam o futuro. Com mais de duas décadas de experiência combinada, a nossa equipa especializa-se em guiar organizações através de desafios complexos e oportunidades transformadoras.',
      p2: 'A nossa abordagem baseia-se em três princípios fundamentais: profundo conhecimento da indústria, análise baseada em dados e parceria colaborativa. Não fornecemos apenas recomendações; trabalhamos lado a lado com a sua equipa para implementar soluções sustentáveis que geram resultados mensuráveis. Desde startups à procura de crescimento rápido a empresas estabelecidas a navegar disrupções de mercado, adaptamos os nossos serviços às suas necessidades únicas.',
      p3: 'O que nos distingue é o nosso compromisso com a excelência e o nosso histórico de sucesso. Os nossos clientes atingem consistentemente os seus objetivos estratégicos, seja a entrar em novos mercados, otimizar operações ou posicionar-se para uma vantagem competitiva a longo prazo. Ao associar-se à Crossroads Consulting LDA, ganha mais do que um consultor—ganha um conselheiro de confiança dedicado ao seu sucesso.',
    },
    services: {
      title: 'Os Nossos Serviços',
      subtitle:
        'Soluções de consultoria abrangentes desenhadas para acelerar o crescimento do seu negócio e a excelência operacional',
      items: {
        strategic: {
          title: 'Planeamento Estratégico',
          desc: 'Desenvolva estratégias claras e acionáveis que se alinham com a sua visão e impulsionam o crescimento sustentável em mercados competitivos.',
        },
        business: {
          title: 'Desenvolvimento de Negócios',
          desc: 'Identifique e capitalize novas oportunidades, expanda a sua presença no mercado e construa parcerias estratégicas.',
        },
        market: {
          title: 'Análise de Mercado',
          desc: 'Obtenha conhecimentos profundos sobre tendências de mercado, cenários competitivos e comportamentos dos clientes para informar a tomada de decisão.',
        },
        operations: {
          title: 'Otimização de Operações',
          desc: 'Otimize processos, reduza custos e melhore a eficiência em toda a sua organização para máxima produtividade.',
        },
        financial: {
          title: 'Consultoria Financeira',
          desc: 'Navegue por decisões financeiras complexas com orientação especializada em orçamentação, previsões e alocação de capital.',
        },
        change: {
          title: 'Gestão da Mudança',
          desc: 'Lidere a transformação organizacional com abordagens estruturadas que garantem transições suaves e o envolvimento das partes interessadas.',
        },
      },
    },
    contact: {
      title: 'Entre em Contacto',
      subtitle:
        'Pronto para levar o seu negócio ao próximo nível? Contacte-nos hoje para discutir como podemos ajudá-lo a atingir os seus objetivos.',
      form: {
        name: 'Nome *',
        email: 'Email *',
        message: 'Mensagem *',
        submit: 'Enviar Mensagem',
        sending: 'A enviar...',
        success:
          'Obrigado pela sua mensagem! Entraremos em contacto brevemente.',
        errors: {
          nameRequired: 'O nome é obrigatório',
          emailRequired: 'O email é obrigatório',
          emailInvalid: 'Por favor introduza um email válido',
          messageRequired: 'A mensagem é obrigatória',
          sendFailed:
            'Falha ao enviar mensagem. Por favor tente novamente ou contacte-nos diretamente por email.',
        },
      },
      info: {
        title: 'Informações de Contacto',
        desc: 'Estamos aqui para responder às suas questões e discutir como podemos apoiar os seus objetivos de negócio.',
        address: {
          label: 'Morada',
          value: [
            'Avenida Empresarial 123',
            'Escritório 456',
            'Lisboa, Portugal 1000-001',
          ],
        },
        phone: {
          label: 'Telefone',
        },
        email: {
          label: 'Email',
        },
        hours: {
          title: 'Horário de Funcionamento',
          weekdays: 'Segunda a Sexta: 9:00 - 18:00',
          weekend: 'Sábado e Domingo: Encerrado',
        },
      },
    },
    footer: {
      rights:
        '© 2026 Crossroads Consulting LDA. Todos os direitos reservados.',
    },
  },
}
